module.exports = __webpack_public_path__ + "static/media/cix.91af0f00.svg";